module.exports = function initPages($) {
  if (typeof $ !== "function" || typeof $.fn !== "object") {
    console.error("initPages: bad $", $);
    throw new Error("initPages: bad jQuery");
  }

  if (typeof $.type !== "function") {
    $.type = function (obj) {
      if (obj == null) return String(obj);
      return Object.prototype.toString.call(obj).slice(8, -1).toLowerCase();
    };
  }

  // slick цепляется к глобальному jQuery
  window.$ = window.jQuery = $;

  require("slick-carousel");
  require("slick-carousel/slick/slick.css");
  require("slick-carousel/slick/slick-theme.css");

  // a.href linker
  $.fn.link = function () {
    return $('[data-target="' + this.data("link") + '"]');
  };

  $(document).on("mouseover", "[data-link]", function () {
    $(this).link().addClass("hover");
  });

  $(document).on("mouseout", "[data-link]", function () {
    $(this).link().removeClass("hover");
  });

  $(document).on("click", "[data-link]", function () {
    if ($("body").hasClass("ready-for-edit")) return;

    const $t = $(this).link();
    const to = $t.attr("href");

    if ($t.attr("target") === "_blank") {
      if (to) window.open(to, "New");
    } else {
      if (to) location.href = to;
    }
  });

  $(".slider-array").on("click touchstart", function (e) {
    e.preventDefault();
    const _ = $(this);
    _.addClass("animated");
    setTimeout(() => _.removeClass("animated"), 300);
  });

  $(function () {
    let current = 0;
    let timer = null;
    const AUTOPLAY_DELAY = 4000; // 5 секунд

    const show = function (i) {
      const cnt = $("[data-slider-block]");
      cnt.children().removeClass("current");

      $.each(cnt, function () {
        $(this).children().eq(i).addClass("current");
      });

      if (location.hash === "" && i === 0) return;

      location.hash = $("[data-anchors] a")[i].dataset["anchor"];

      $("[data-lang-select] a").each(function () {
        this.href = this.href.split("#")[0] + location.hash;
      });
    };

    const next = function () {
      const cnt = $("[data-slider-block]:first").children();
      current += 1;
      if (current >= cnt.length) current = 0;
      show(current);
    };

    const prev = function () {
      const cnt = $("[data-slider-block]:first").children();
      current -= 1;
      if (current < 0) current = cnt.length - 1;
      show(current);
    };

    const startAutoplay = function () {
      stopAutoplay();
      timer = setInterval(next, AUTOPLAY_DELAY);
    };

    const stopAutoplay = function () {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    };

    $("[data-slider-arrow]").on("click touchstart", function (e) {
      e.preventDefault();
      stopAutoplay();

      const direction = $(this).data("slider-arrow");
      if (direction === "next") next();
      if (direction === "prev") prev();

      startAutoplay();
    });

    $("[data-slider-preview-item]").on("click touchstart", function (e) {
      e.preventDefault();
      stopAutoplay();
      current = $(this).parent().index();
      show(current);
      startAutoplay();
    });

    // Пауза при наведении (по желанию, но обычно must-have)
    $("[data-slider-block]").on("mouseenter", stopAutoplay);
    $("[data-slider-block]").on("mouseleave", startAutoplay);

    if (location.hash !== "") {
      const el = $(
        '[data-anchors] a[data-anchor="' + location.hash.substr(1) + '"]',
      );
      if (el && el.length) {
        current = el.index();
        show(current);
      }
    } else {
      show(0);
    }

    startAutoplay();
  });

  $(function () {
    const cnt = $("[data-list-advantages] [data-slick]");

    cnt
      .slick({
        autoplay: false,
        arrows: false,
        infinite: false,
        centerPadding: "25px",
        centerMode: false,
        variableWidth: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
          { breakpoint: 3000, settings: "unslick" },
          {
            breakpoint: window.sizes.XS,
            settings: { slidesToShow: 1, slidesToScroll: 1 },
          },
        ],
      })
      .on("beforeChange", function (event, slick, currentSlide, nextSlide) {
        const t = 1 + nextSlide;
        $("[data-slider-start]").text("0" + t);
        const now = (100 / count) * (nextSlide + 1);
        $("[data-slider-progress-line]").css({ width: now + "%" });
      });

    const count = $("[data-slick]").find(".slick-track").children().length;
    $("[data-slider-end]").text("0" + count);
    $("[data-slider-progress-line]").css({ width: 25 + "%" });

    $("[data-list-advantages] .slider-array").on(
      "click touchstart",
      function (e) {
        e.preventDefault();
        cnt.slick($(this).data("action"));
      },
    );
  });

  $(function () {
    const cnt = $("[data-slick-bottom]");

    cnt.slick({
      autoplay: false,
      arrows: false,
      infinite: false,
      centerPadding: "20px",
      centerMode: false,
      variableWidth: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      responsive: [
        { breakpoint: 3000, settings: "unslick" },
        {
          breakpoint: window.sizes.XS,
          settings: { slidesToShow: 1, slidesToScroll: 1 },
        },
      ],
    });

    $("[data-slick-bottom-arrows] a").on("click touchstart", function (e) {
      e.preventDefault();
      cnt.slick($(this).data("action"));
    });
  });

  $(function () {
    const $list = $("[data-included-gallery-list]");
    const $modal = $("[data-included-gallery-modal]");
    const $slider = $("[data-included-gallery-slider]");
    if (!$list.length || !$modal.length || !$slider.length) return;

    const open = (index) => {
      $modal.addClass("is-open");
      $("body").addClass("modal-open");
      if (!$slider.hasClass("slick-initialized")) {
        $slider.slick({
          arrows: true,
          dots: false,
          infinite: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          adaptiveHeight: true,
          prevArrow:
            '<button type="button" class="included-arrow slick-prev" aria-label="Previous"><img src="/static/images/svg/back.svg" alt=""></button>',
          nextArrow:
            '<button type="button" class="included-arrow slick-next" aria-label="Next"><img src="/static/images/svg/back.svg" alt=""></button>',
        });
      }
      $slider.slick("slickGoTo", index || 0, true);
    };

    const close = () => {
      $modal.removeClass("is-open");
      $("body").removeClass("modal-open");
    };

    $list.on("click", "[data-included-index]", function (e) {
      e.preventDefault();
      const index = parseInt($(this).data("included-index"), 10) || 0;
      open(index);
    });

    $modal.on("click", "[data-included-close]", function (e) {
      e.preventDefault();
      close();
    });

    $modal.on("click", function (e) {
      if (e.target === this) close();
    });

    $(document).on("keydown", function (e) {
      if (e.key === "Escape") close();
    });
  });
};
